module.exports = __webpack_public_path__ + "img/Roc.2c2d32e7.jpeg";